<template>
  <div :class="[css]">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  css: {
    type: String,
    default: 'section-wrapper',
  },
});
const { css } = props;
</script>

<style scoped lang="css">
@reference "tailwindcss";
@reference "tailwindcss/utilities";

.section-wrapper {
  @apply p-4 mb-4 border-solid border;
  background-color: var(--p-toolbar-background);
  border: 1px solid var(--p-toolbar-border-color);
}

.secondary {
  background-color: transparent;
  border: 1px solid transparent;
}

.ai-section {
  @apply p-4 mb-4 border-solid border;
  background-color: var(--p-toolbar-background);
  border: 1px solid #a855f7;
}
</style>
